import { createContext, useContext } from 'react';

import { reportErrorToBugsnag } from '@air/utils-error';

import { isDevOrTestStage } from '~/swr-hooks/utils';

export type UploadInputType = 'files' | 'folders';

export type OpenUploaderParams = {
  type?: UploadInputType;
  /**
   * Skip the current-board direct-upload shortcut so the caller can pick a
   * destination (PreUploadModal). Used by workspace-level surfaces such as the
   * Uploads pane, which are not uploading into the page the user happens to be on.
   */
  pickDestination?: boolean;
};

export type UploadContextType = {
  openUploader: (params?: OpenUploaderParams) => void;
};

const defaultUploadContextValue: UploadContextType = {
  openUploader: () => undefined,
};

export const UploadContext = createContext<UploadContextType>(defaultUploadContextValue);

export const useUploadContext = () => {
  const ctx = useContext(UploadContext);

  if (ctx === defaultUploadContextValue) {
    const error = new Error('useUploadContext must be used within an UploadContext provider');

    if (isDevOrTestStage()) {
      throw error;
    }

    reportErrorToBugsnag({
      error,
      context: error.message,
    });
  }

  return ctx;
};
